import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Meta, Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {UtilitiesService} from '../../../service/utilities.service';
import {StatePersistenceService} from '../../../service/state.persistence.service';
import {BaseComponent} from '../../../common/component/base/base.component';
import {BreadcrumbService} from '../../../service/breadcrumb.service';
import {NewsItem} from "../../model/news-item";

const selector: string = 'the-next-electricity-crisis';

@Component({
    selector: selector,
    templateUrl: './the-next-electricity-crisis.component.html',
    styleUrls: ['../trending.component.scss']
})
export class TheNextElectricityCrisisComponent extends BaseComponent {

    activated: boolean;
    articles: NewsItem[] = [];

    constructor(@Inject(DOCUMENT) public override document: Document,
                private title: Title,
                private meta: Meta,
                private utilities: UtilitiesService,
                private state: StatePersistenceService,
                private route: ActivatedRoute,
                router: Router,
                breadcrumbService: BreadcrumbService) {
        super(document, router, breadcrumbService);
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any): void => {
            const url: string = event.url;
            this.activated = (url.substring(url.lastIndexOf('/') + 1) === selector);
        });
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.articles.push({
            title: 'Private solar is helping to keep the lights on',
            imgSrc: '/assets/images/news/trending/2024-04-15/1.jpg',
            routerLink: '/latest-news/private-solar-is-helping-to-keep-the-lights-on',
            articleDate: 'APRIL 2024',
            author: 'MONEYWEB',
            authorShort: 'mw'
        }, {
            title: 'How to maximise solar panel performance in winter',
            imgSrc: '/assets/images/news/trending/2024-06-01/1.jpg',
            routerLink: '/latest-news/how-to-maximise-solar-panel-performance-in-winter',
            articleDate: 'MAY 2024',
            author: 'TECHCENTRAL',
            authorShort: 'tc'
        }, {
            title: 'Big slowdown in solar installations in South Africa',
            imgSrc: '/assets/images/news/trending/2024-07-03/1.png',
            routerLink: '/latest-news/big-slowdown-in-solar-installations-in-south-africa',
            articleDate: 'JULY 2024',
            author: 'TECHCENTRAL',
            authorShort: 'tc'
        }, {
            title: 'What you should know before installing solar panels and batteries at your home',
            imgSrc: '/assets/images/news/trending/2022-07-08/1.jpg',
            routerLink: '/latest-news/what-you-should-know-before-installing-solar-panels-and-batteries',
            articleDate: 'JULY 2022',
            author: 'MYBROADBAND',
            authorShort: 'mbb'
        }, {
            title: 'Good news for solar in South Africa',
            imgSrc: '/assets/images/news/trending/2022-07-25/1.jpg',
            routerLink: '/latest-news/good-news-for-solar-in-south-africa',
            articleDate: 'JULY 2022',
            author: 'BUSINESSTECH',
            authorShort: 'bt'
        }, {
            title: 'Solar Energy',
            imgSrc: '/assets/images/news/trending/2022-09-12/1.jpg',
            routerLink: '/latest-news/solar-energy',
            articleDate: 'SEPTEMBER 2022',
            author: 'MAIL & GUARDIAN',
            authorShort: 'mg'
        }, {
            title: 'Beyond Eskom’s 12. 74%: The devil’s in the details',
            imgSrc: '/assets/images/news/trending/2025-08-01/1.png',
            routerLink: '/latest-news/beyond-eskoms-latest-increase',
            articleDate: 'AUGUST 2025',
            author: 'IOL.CO.ZA',
            authorShort: 'iol'
        });
    }
}
